<template>
  <div id="loading-bg">
    <div class="loading" v-if="loading">
      <loader :loading-bar="false" />
    </div>
    <div v-if="expired" class="div">
      <h1>
        Your session has expired. <br />
        We will redirect you to the login page.
      </h1>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import isTokenValid from "@/utilities/tokenValidator";

export default {
  name: "TokenStaging",
  components: { Loader },
  data() {
    return {
      loading: true,
      expired: false,
      domain: ''
    };
  },
  created() {
    this.initTokenFlow();
  },
  watch: {
    expired(newVal) {
      if (newVal) {
        setTimeout(() => {
          window.location.replace(
            `${process.env.VUE_APP_CLOUDENLY}sign-in/?domain=${this.domain}`
          );
        }, 1000);
      }
    },
  },
  methods: {
    async initTokenFlow() {
      try {
        localStorage.setItem("hasRefreshed", "false");
        const { action, request, linchpin, domainName } = this.$route.query;
        this.domain = domainName || "";

        if (action && request) {
          localStorage.setItem("action", action);
          localStorage.setItem("request", request);
        }

        if (linchpin) {
          await this.handleFreshLinchpin();
        } else {
          this.handleLocalFallback();
        }
      } catch (error) {
        this.loading = false;
        this.expired = true;
      }
    },

    async handleFreshLinchpin() {
      try {
        const data = await this.$_getLinchpin();
        const parsed = data?.data;

        if (!parsed || !parsed.token || !parsed.user) {
          throw new Error("Invalid linchpin data");
        }

        localStorage.setItem("token", parsed.token);
        localStorage.setItem("linchpin", JSON.stringify(parsed));
        this.$store.commit("UPDATE_STATE_FROM_LOCALSTORAGE", null, { root: true });

        this.redirectBasedOnUser(parsed.user, parsed.org);
      } catch (error) {
        this.handleLocalFallback(); // fallback if request fails
      }
    },

    handleLocalFallback() {
      const stored = localStorage.getItem("linchpin");
      if (!stored) {
        this.loading = false;
        this.expired = true;
        return;
      }

      const parsed = JSON.parse(stored);
      const token = localStorage.getItem("token");

      if (!isTokenValid(token)) {
        this.loading = false;
        this.expired = true;
        return;
      }

      this.redirectBasedOnUser(parsed.user, parsed.org);
    },

    redirectBasedOnUser(user, org) {
      const action = localStorage.getItem("action");
      const request = localStorage.getItem("request");
      const routeName = localStorage.getItem("routeName");

      if (user.isEmployee) {
        if (action && request) {
          this.$router.push({ name: `Ess${action}`, params: { id: request } });
        } else {
          this.$router.push({name: routeName || "EssDashboard"});
          localStorage.removeItem('routeName')
        }
      } else if (!user.roles?.humanar && !user.isRoot) {
        window.location.replace(
          `${process.env.VUE_APP_CLOUDENLY}sign-in/?domain=${org?.alias || "default"}`
        );
      } else if (action && request) {
          this.$router.push({name: action, params: {id: request}});
        } else {
          this.$router.push({name: routeName || "AdminDashboard"});
          localStorage.removeItem('routeName')
        }
    },
  },
};
</script>

<style scoped>
.div {
  font-size: 1.7rem;
  text-align: center;
  font-weight: 700;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#loading-bg {
  width: 100%;
  height: 100%;
  background: #fff;
  display: block;
  position: absolute;
}

.loading {
  position: absolute;
  left: calc(50% - 35px);
  top: 50%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
</style>
